const BASE = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.01_LoanContracting.';

export default {
  BREADCRUMB_01: `${BASE}mbLoanContracting.breadcrumb01`,
  BREADCRUMB_02: `${BASE}mbLoanContracting.breadcrumb02`,
  HEADER_TITLE: `${BASE}mbLoanContracting.header`,
};
